import MyImage from '@shared/components/myImage'
import React from 'react'
import styles from './style.module.scss'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import CustomLink from '@shared/components/customLink'

export default function ArticleBigOlympics({ article }) {
  return (
    <CustomLink href={`/${article?.oSeo?.sSlug}` || ''} prefetch={false}>
    <div className='cursor-pointer'>
        <figure className="op-tracker">
            <div className={`${styles.postImg} position-relative overflow-hidden`}>
                <MyImage
                    priority={true}
                    // src={'https://www.oneturf.news/_next/image?url=https%3A%2F%2Fmedia.oneturf.news%2Fmedia%2Fattachments%2FANI-20240519161323_1716141600363.jpg&w=1190&q=70'}
                    src={getImgURL(article?.oImg?.sUrl) || noImage}
                    alt={article?.oImg?.sText || article?.sSrtTitle}
                    placeholder="blur"
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    height="140"
                    width="256"
                    layout="responsive"
                    sizes="(max-width: 767px) 320px, (max-width: 991px) 360px, (max-width: 1190px) 400px, 600px"
                />
                <div className={`${styles.titleContent} d-flex flex-column`}>
                    <div>
                        {/* lorem2 */}
                        {article?.sTitle}
                    </div>
                    {article?.oImg?.sCaption !== 'null' && (
                    <figcaption
                        className={`${styles.caption}`}
                        dangerouslySetInnerHTML={{ __html: article?.oImg?.sCaption }}
                    />
                    )}
                </div>
            </div>
        </figure>
    </div>
    </CustomLink>
  )
}
ArticleBigOlympics.propTypes = {
  article: PropTypes.object
}
